import { useContext, useEffect, useState } from "react";
import { calculateAge } from "../../../../helpers/helper";
import { postUseDevice } from "../../../../services/httpService/deviceRequest";
import { getPatient } from "../../../../services/httpService/patientRequest";
import { deviceUseValidator } from "../../../../validators/DeviceValidator";
import { GlobalContext } from "../../../contexts/globalContext";
import Modal from "../../atoms/Modal/Modal";

const MODES = [
  { key: "basic", label: "Basic" },
  { key: "spirometer", label: "Spirometer" },
];

const DEFAULT_STATE = {
  patient: "",
  mode: MODES[0].key,
  patientDetail: "",
  error: "",
};
const ModalDeviceUse = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [state, setState] = useState(DEFAULT_STATE);
  const [patients, setPatients] = useState([]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "patient") {
      let patientIdx = patients.findIndex((patient) => patient._id === value);
      let patientDetail = patientIdx > -1 ? patients[patientIdx] : "";
      setState((prevState) => ({ ...prevState, [name]: value, patientDetail }));
    } else {
      setState((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleClose = () => {
    setState(DEFAULT_STATE);
    if (props.handleClose) props.handleClose();
  };

  const handleSubmit = async () => {
    try {
      const { error } = await deviceUseValidator({
        patient: state.patient,
        patientDetail: state.patientDetail,
      });

      if (error) throw new Error(error.details[0].message);

      dispatch("isLoading", true);
      await postUseDevice({
        _id: props._id,
        action: "use",
        doctor: sharedState.user._id,
        patient: state.patient,
        mode: state.mode,
      });
      dispatch("isLoading", false);
      props.handleClose();
      props.handleUpdate();
    } catch (error) {
      let message;
      switch (error.message) {
        case "The device is being used by someone else. Please ask him to reset.":
          message =
            "Perangkat saat ini terhubung dengan akun lain. Mohon lakukan pengaturan ulang.";
          break;

        default:
          message = error.message;
          break;
      }
      dispatch("alert", {
        type: "warning",
        message: message,
        show: true,
      });
      dispatch("isLoading", false);
    }
  };

  const handleGetPatients = async () => {
    try {
      let { result } = await getPatient(
        `doctor=${sharedState.user._id}&orderBy=name`
      );
      if (result.length === 0) {
        setState((prevState) => ({
          ...prevState,
          error:
            "Anda belum memiliki pasien. Silakan daftarkan pasien terlebih dahulu",
        }));
      }

      result = result.map((res) => {
        res.user.profile["age"] = calculateAge(res.user.profile.dateOfBirth);
        delete res.user.profile.dateOfBirth;
        return res;
      });
      result.sort((a, b) =>
        a.user.name > b.user.name ? 1 : b.user.name > a.user.name ? -1 : 0
      );
      setPatients(result);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    handleGetPatients();
  }, []);

  useEffect(() => {
    if (props.show === true && state.error !== "") {
      dispatch("alert", {
        show: true,
        message: state.error,
        type: "warning",
      });
      props.handleClose();
    }
  }, [props.show]);

  return (
    <Modal
      show={props.show}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      submitLabel="Terapkan"
    >
      <div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Nama Perangkat</div>
          <div
            className={
              "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-40 text-gray-700 px-2 md:px-3 py-1 rounded-lg "
            }
          >
            {props._id}
          </div>
        </div>
        {process.env.NODE_ENV === "development" && (
          <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
            <div className="col-span-12 sm:col-span-3">Mode</div>
            <select
              className="col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-20 focus:bg-opacity-30 text-gray-700 px-2 py-1 rounded-lg focus:outline-none "
              name="mode"
              value={state.mode}
              onChange={handleChange}
            >
              {MODES.map((mode) => (
                <option key={"mode" + mode.label} value={mode.key}>
                  {mode.label}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Pilih ID Pasien</div>
          <input
            list={"patients"}
            className={
              "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-20 focus:bg-opacity-30 text-gray-700 px-2 md:px-3 py-1 rounded-lg focus:outline-none "
            }
            name="patient"
            placeholder="Nama Pasien"
            value={state.patient}
            onChange={handleChange}
          />
          <datalist id="patients">
            {patients.map((patient) => (
              <option key={"patient" + patient._id} value={patient._id}>
                {`${patient.user.name} ${
                  patient.user.profile.isMale ? "- Laki-laki" : "- Perempuan"
                } ${
                  patient.user.profile.age
                    ? `- ${patient.user.profile.age} Tahun `
                    : ""
                }`}
              </option>
            ))}
          </datalist>
        </div>

        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Profil Pasien</div>
          <div
            className={
              "col-span-12 sm:col-span-9 w-full  bg-opacity-20 focus:bg-opacity-30 text-gray-700 px-2 md:px-3 py-1 rounded-lg " +
              (state.patientDetail ? "bg-primary" : "bg-warning")
            }
          >
            {state.patientDetail
              ? `${state.patientDetail.user.name} ${
                  state.patientDetail.user.profile.isMale
                    ? "- Laki-laki"
                    : "- Perempuan"
                } ${
                  state.patientDetail.user.profile.age
                    ? `- ${state.patientDetail.user.profile.age} Tahun `
                    : ""
                }`
              : "Id Pasien Tidak diketahui"}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalDeviceUse;
